/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
// Adopted from: https://github.com/davidchambers/Base64.js
export default class Base64 {
    /**
     * @type {string}
     * @const
     */
    static CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

    /**
     * Encode a string as url safe base64.
     *
     * @param {string} input
     *
     * @return {string}
     */
    public static encode(input: string) {
        let output = "";
        for (
            // initialize result and counter
            let block = 0, charCode, idx = 0, map = Base64.CHARS;
            // if the next str index does not exist:
            //   change the mapping table to "="
            //   check if d has no fractional digits
            input.charAt(idx | 0) || ((map = "="), idx % 1);
            // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
            output += map.charAt(63 & (block >> (8 - (idx % 1) * 8)))
        ) {
            charCode = input.charCodeAt((idx += 3 / 4));
            block = (block << 8) | charCode;
        }
        return output.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    }

    public static decode(input: string) {
        if (input.length % 4 !== 0) {
            input += new Array(5 - (input.length % 4)).join("=");
        }

        input = input.replace(/\-/g, "+").replace(/\_/g, "/");

        const str = input.replace(/=+$/, "");
        let bc = 0;
        let bs = 0;
        let buffer;
        let idx = 0;
        let output = "";
        for (
            ;
            // get next character
            (buffer = str.charAt(idx++));
            // character found in table? initialize bit storage and add its ascii value;
            ~buffer &&
            ((bs = bc % 4 ? bs * 64 + buffer : buffer),
            // and if not first of each 4 characters,
            // convert the first 8 bits to one ascii character
            bc++ % 4)
                ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
                : 0
        ) {
            // try to find character in table (0-63, not found => -1)
            buffer = Base64.CHARS.indexOf(buffer);
        }
        return output;
    }
}
